export enum MOBILE_SELECT_VARIABLES {
  backgroundColor = '--background-color',
  textColor = '--text-color',
  activeTextColor = '--active-text-color',
}

export const CLASSNAME_PREFIX = 'solution-select';
